import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { AuthSelectors } from '@app/modules/Auth'
import { NavBarEntry } from '@app/NavBar'
import { useNavBarCountersLazyQuery } from '@app/queries/NavBar/NavBarCounters.queries'

import { getPostponedLetterRequestsPath } from './paths'

export function usePostponedLetterRequestsNavbarEntries(): NavBarEntry[] {
  const lawyerId = useSelector(AuthSelectors.getUserId)
  const location = useLocation()

  const [count, { data }] = useNavBarCountersLazyQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      lawyerId
    }
  })

  useEffect(() => {
    count()
  }, [location])

  return [
    {
      counter: data?.postponedLetterRequests ?? 0,
      iconName: 'letter',
      title: 'Anwaltsschreiben',
      EntryWrapper: ({ children }) => <Link to={getPostponedLetterRequestsPath()}>{children}</Link>,
      active: /^\/anwaltsschreiben/
    }
  ]
}
